import React from 'react';
import { useHits } from 'react-instantsearch';

export default function PageHits() {
    const { hits } = useHits();

    if (hits.length === 0) return null;

    return (
        <div className="col-12">
            <p className="font-weight-bold mb-6">{window.Translator.trans('app.header.search.results.pages')}</p>
            <div className="row gutters-2">
                {hits.slice(0, 5).map((result, index) => (
                    <div key={index} className="col-12">
                        <a className="text-decoration-none text--14" href={result?.url} target="_self">
                            {result?.title}
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
}
